import { CompanyInfo } from '../company/company-info';
import { InvestmentModel } from './investment.model';

export class MyInvestment {
  campaignStatus: number;
  campaignType: string;
  company: CompanyInfo;
  endAt: string;
  equityOffered: number;
  fundedAmount: number;
  id: number;
  investmentAmount: number;
  investments: InvestmentModel[];
  isAngelTaxIncentive: boolean;
  isCreator: boolean;
  isFavourite: boolean;
  largestInvestmentAmount: number;
  maximumTargetAmount: number;
  minimumTargetAmount: number;
  name: string;
  preLiveEndAt: string;
  preLiveStartAt: string;
  raisedPercentage: number;
  rssUrl: string;
  shareQuantity: number;
  slug: string;
  startAt: string;
  valuationAmount: number;
}
